<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">

      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称">
            <a-input-search :read-only="true" enterButton="选择" @search="onSearch" placeholder="请选择产品" v-decorator="[
          'productName',
          {rules: [{ required: true, message: '请选择产品' }],initialValue:data.productName}]"></a-input-search>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编码">
            <a-input :read-only="true" placeholder="" v-decorator="[
          'productCode',
          {initialValue:data.productCode,rules: [{ required: false, message: '' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品规格">
            <a-input :read-only="true" placeholder="" v-decorator="[
          'productSpecDes',
          {initialValue:data.productSpecDes,rules: [{ required: false, message: '' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="显示属性">
            <a-input :read-only="params.isShow" placeholder="请输入显示属性" v-decorator="[
          'specDes',
          {initialValue:data.specDes,rules: [{ required: true, message: '请输入显示属性' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
    <hp-manager-modal width="1200px" :title="'选择产品'" v-model="selectProductVisible">
      <hp-manager-page-product-select slot="slot" @getSelectedProduct="getSelectedProduct" @cancel="selectProductVisible = false"></hp-manager-page-product-select>
    </hp-manager-modal>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import hpManagerPageProductSelect from "./../../Goods/Product/SelectProduct";
import { fail } from "assert";
const defaultData = {
  id: 0,
  productName: "",
  productCode: "",
  productSpecDes: "",
  productUnionId: 0,
  specDes: ""
};
export default {
  name: "hp-manager-page-item-add",
  mixins: [account, dateFormat],
  components: {
    hpManagerPageProductSelect
  },
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      selectProductVisible: false,
      productId: 0
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getProductUnionItem();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    onSearch(type) {
      this.selectProductVisible = true;
    },

    cancel() {
      this.$emit("cancel");
    },
    getSelectedProduct(p) {
      this.selectProductVisible = false;
      this.form.setFields({
        productName: { value: p.productName, errors: null }
      });
      this.form.setFields({
        productCode: { value: p.productCode, errors: null }
      });
      this.form.setFields({
        productSpecDes: { value: p.specDes, errors: null }
      });
      this.productId = p.id;
    },
    async getProductUnionItem() {
      this.loading = true;
      let result = await api.GetProductUnionItem({ id: this.params.id });
      if (result) {
        this.data = result;
        this.productId = this.data.productId;
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        specDes: value.specDes,
        productUnionId: this.params.productUnionId,
        productId: this.productId
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.AddOrUpdateProductUnionItem(requestData);
        if (data) {
          if (this.params.id > 0) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          } else {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Goods/ProductUnion/AddItem.vue